import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { BackButton } from "@songtradr-one/components-frontend";
import { SubModuleType } from "@songtradr-one/shared-common";
import { Container, Dot, Props, Text } from "./NavBarLink.Parts";

export const NavBarLink = ({ text, route, active, onClick, type }: Props) => {
  const navigate = useNavigate();
  const linkTypes: Partial<Record<SubModuleType, ReactNode>> = {
    [SubModuleType.LINK]: (
      <>
        <Dot $active={active} />
        <Text variant="normal-strong" $active={active}>
          {text}
        </Text>
      </>
    ),
    [SubModuleType.BACKBUTTON]: (
      <BackButton label={text} onClick={() => navigate(route)} />
    ),
  };
  return (
    <Container
      $active={active}
      tabIndex={active ? -1 : 0}
      to={route}
      onClick={onClick}
    >
      {linkTypes[type ?? SubModuleType.LINK]}
    </Container>
  );
};
